document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wp-block-create-block-cityprop-moving-header').forEach(block => {
        var prevScrollpos = window.pageYOffset;
        var scrollThreshold = 50;
        var headerBottom = (block.offsetTop + block.offsetHeight) * 2;
        var lastVisibleScroll = prevScrollpos;

        document.addEventListener("horizontalscrollstart", function (e) {
            if (e.detail?.enter) {
                block.classList.add("horizontal-scroll")
            } else if (e.detail?.leave) {
                block.classList.remove("horizontal-scroll");
            }
        })

        window.onscroll = function () {
            var currentScrollPos = window.scrollY;

            if (currentScrollPos < headerBottom) {
                block.classList.remove("fixed-totop");
                block.classList.remove("remove-fromview");
                createUpdateEvent({fixedToTop: false});
                return;
            }

            if (currentScrollPos >= headerBottom) {
                block.classList.add("fixed-totop");
            }
            createUpdateEvent({fixedToTop: true})

            if (prevScrollpos <= currentScrollPos) {
                block.classList.add("remove-fromview");

                lastVisibleScroll = currentScrollPos;
            }
            else {
                if (lastVisibleScroll - currentScrollPos >= scrollThreshold) {
                    block.classList.remove("remove-fromview");
                }
            }

            prevScrollpos = currentScrollPos;
        }
    });
});

function createUpdateEvent(data) {
	const myEvent = new CustomEvent("cp-moving-header", {
		detail: data
	});

	document.dispatchEvent(myEvent);
}